import theme from "theme";

const { default: styled } = require("@emotion/styled");

const CardContainerStyle = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 1.25rem;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  height: 100%;
  width: 100%;
  min-width: 0;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }
  
  @media (min-width: 640px) {
    padding: 2rem;
    border-radius: 1.5rem;
  }
  
  @media (min-width: 1024px) {
    padding: 2.5rem;
  }
  
  @media (min-width: 1280px) {
    padding: 3rem;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const HeaderStyle = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  background: linear-gradient(135deg, #E36E00 0%, #FFAE00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.3px;
  line-height: 1.2;
  
  @media (min-width: 640px) {
    font-size: 1.5rem;
  }
  
  @media (min-width: 1024px) {
    font-size: 1.75rem;
  }
  
  @media (min-width: 1280px) {
    font-size: 2rem;
  }
`;

const CountStyle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #E36E00;
  padding: 6px 12px;
  background: rgba(227, 110, 0, 0.1);
  border-radius: ${theme.modernTokens.borderRadius.full};
  border: 1px solid rgba(227, 110, 0, 0.2);
  
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 4px 8px;
  }
`;

const SC = {
  CardContainerStyle,
  HeaderStyle,
  CountStyle,
  HeaderContainer,
};

export default SC;
